import type { SetRequiredAndNonNullable } from '@festina-life/core'
import type { FPlusViewerAlignment } from '@festina-life/fplus'
import cx from 'classnames'
import React from 'react'

import { expressionItemClassName } from './helpers'
import type { LiteralTypeInformation } from './types'

type Props = {
  alignment: FPlusViewerAlignment
  typeInformation: SetRequiredAndNonNullable<LiteralTypeInformation, 'value'>
}

export const LiteralExpressionListViewer = ({
  alignment,
  typeInformation,
}: Props) => (
  <div
    className={cx('flex flex-row gap-x-2 w-full items-center', {
      'justify-center': alignment === 'center',
      'justify-start': alignment === 'left',
    })}
  >
    <div className="font-mono text-[11px]">
      <span>{typeInformation.collectionType === 'list' ? '[ ' : '{ '}</span>
      <span className="whitespace-normal wrap-break-word text-monaco-codeEnum dark:text-monaco-codeEnumDark">
        {typeInformation.value.map((item, index) => (
          // oxlint-disable-next-line react/no-array-index-key
          <React.Fragment key={index}>
            <span
              className={
                typeInformation.literalType
                  ? (expressionItemClassName[typeInformation.literalType] ?? '')
                  : ''
              }
            >
              {item}
            </span>
            {index < typeInformation.value.length - 1 && <span>, </span>}
          </React.Fragment>
        ))}
      </span>
      <span>{typeInformation.collectionType === 'list' ? ' ]' : ' }'}</span>
    </div>
  </div>
)
